<div class="card border-primary mb-3" [formGroup]="form">
  <div class="card-header">
    <strong>Documents presented for Form I-9</strong>
  </div>
  <div class="card-body">
    <p class="text-muted">
      Choose the document presented. The form will place it in List A, or require one document from both List B and List C.
    </p>

    <div class="form-group">
      <label for="i9PrimaryDocument"><strong>Document Type</strong></label>
      <p-select inputId="i9PrimaryDocument"
                styleClass="app-select w-100"
                [options]="primaryDocumentOptions"
                optionLabel="label"
                [filter]="true"
                [showClear]="true"
                placeholder="Select a List A or List B document..."
                [(ngModel)]="primaryDocument"
                [ngModelOptions]="{standalone: true}"
                (onChange)="selectPrimaryDocument($event.value)"></p-select>
      <small class="text-danger" *ngIf="form.touched && !primaryDocument">Select a document type.</small>
    </div>

    <div class="alert alert-info" *ngIf="usesListA">
      This is a List A document. Do not enter List B or List C documents.
    </div>
    <div class="alert alert-info" *ngIf="usesListBAndC">
      This is a List B document. You must also select one List C document.
    </div>
    <div class="alert alert-warning" *ngIf="primaryDocument?.legacy || listCDocument?.legacy">
      This submission contains saved document values that are not in the current catalog. Review and edit the manual rows below, or intentionally select a current document type to replace them.
    </div>

    <div class="form-group" *ngIf="isPrimaryReplacementReceipt">
      <label for="i9ReplacementDocument"><strong>Document being replaced</strong></label>
      <ng-container *ngIf="primaryDocument.list === 'A'; else singleReplacementDocument">
        <p-select inputId="i9ReplacementDocument"
                  styleClass="app-select w-100"
                  [options]="listAReplacementDocumentOptions()"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  [showClear]="true"
                  placeholder="Select the document being replaced..."
                  [(ngModel)]="listAReplacementDocumentSelection"
                  [ngModelOptions]="{standalone: true}"
                  (onChange)="selectListAReplacementDocument($event.value)"></p-select>
        <small class="text-danger" *ngIf="form.touched && !listAReplacementDocumentSelection">Select the document being replaced.</small>
      </ng-container>
      <ng-template #singleReplacementDocument>
        <p-select inputId="i9ReplacementDocument"
                  styleClass="app-select w-100"
                  [options]="replacementDocumentOptions(primaryDocument.list, replacementDocumentTitle)"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  [showClear]="true"
                  placeholder="Select the document being replaced..."
                  [(ngModel)]="replacementDocumentTitle"
                  [ngModelOptions]="{standalone: true}"
                  (onChange)="selectReplacementDocument($event.value)"></p-select>
        <small class="text-danger" *ngIf="form.touched && !replacementDocumentTitle">Select the document being replaced.</small>
      </ng-template>
    </div>

    <div class="form-group" *ngIf="usesListBAndC">
      <label for="i9ListCDocument"><strong>List C Document Type</strong></label>
      <p-select inputId="i9ListCDocument"
                styleClass="app-select w-100"
                [options]="listCDocumentOptions"
                optionLabel="label"
                [filter]="true"
                [showClear]="true"
                placeholder="Select a List C document..."
                [(ngModel)]="listCDocument"
                [ngModelOptions]="{standalone: true}"
                (onChange)="selectListCDocument($event.value)"></p-select>
      <small class="text-danger" *ngIf="form.touched && !listCDocument">Select a List C document.</small>
    </div>

    <div class="form-group" *ngIf="isListCReplacementReceipt">
      <label for="i9ListCReplacementDocument"><strong>Document being replaced</strong></label>
      <p-select inputId="i9ListCReplacementDocument"
                styleClass="app-select w-100"
                [options]="replacementDocumentOptions('C', listCReplacementDocumentTitle)"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                placeholder="Select the List C document being replaced..."
                [(ngModel)]="listCReplacementDocumentTitle"
                [ngModelOptions]="{standalone: true}"
                (onChange)="selectListCReplacementDocument($event.value)"></p-select>
      <small class="text-danger" *ngIf="form.touched && !listCReplacementDocumentTitle">Select the document being replaced.</small>
    </div>

    <ng-container *ngFor="let list of ['A', 'B', 'C']">
      <div *ngFor="let row of activeRows($any(list))" class="border-top pt-3 mt-3">
        <h5>List {{list}} Document {{row}}</h5>
        <div class="row">
          <div class="col-12 col-md-6 form-group">
            <label>Document Title</label>
            <input class="form-control" type="text" [readonly]="!isManualRow($any(list))" [formControlName]="controlName(list + row + 'DocumentTitle')" />
          </div>
          <div class="col-12 col-md-6 form-group">
            <label>Issuing Authority</label>
            <p-select styleClass="app-select w-100"
                      [options]="authorityOptions(form.get(controlName(list + row + 'DocumentTitle'))?.value)"
                      [editable]="true"
                      [filter]="true"
                      placeholder="Select or enter the issuing authority..."
                      [formControlName]="controlName(list + row + 'IssuingAuthority')"></p-select>
          </div>
          <div class="col-12 col-md-6 form-group">
            <label>Document Number</label>
            <input class="form-control" type="text" [formControlName]="controlName(list + row + 'DocumentNumber')" />
          </div>
          <div class="col-12 col-md-6 form-group">
            <label>Expiration Date (if any)</label>
            <p-datepicker dateMask
                          inputStyleClass="form-control"
                          styleClass="w-100"
                          [showIcon]="true"
                          [showButtonBar]="true"
                          dateFormat="mm/dd/yy"
                          dataType="string"
                          placeholder="Select date..."
                          [formControlName]="controlName(list + row + 'DocumentExpirationDate')"></p-datepicker>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
